var map = {
	"./cards": 41561,
	"./cards.jsx": 41561,
	"./cards.module.scss": 62080,
	"./charts": 62528,
	"./charts.jsx": 62528,
	"./charts.module.scss": 68844,
	"./client": 54067,
	"./client.jsx": 54067,
	"./client.module.scss": 94514,
	"./details": 30722,
	"./details.jsx": 30722,
	"./details.module.scss": 28435,
	"./documents": 27130,
	"./documents.jsx": 27130,
	"./documents.module.scss": 37680,
	"./icons": 29622,
	"./icons.jsx": 29622,
	"./icons.module.scss": 53087,
	"./image": 42239,
	"./image.jsx": 42239,
	"./image.module.scss": 42134,
	"./list": 70902,
	"./list.jsx": 70902,
	"./list.module.scss": 36807,
	"./notification": 52499,
	"./notification.jsx": 52499,
	"./numberedlist": 83170,
	"./numberedlist.jsx": 83170,
	"./numberedlist.module.scss": 82859,
	"./review": 92518,
	"./review.jsx": 92518,
	"./review.module.scss": 21303,
	"./slashlist": 10555,
	"./slashlist.jsx": 10555,
	"./slashlist.module.scss": 33242,
	"./slider": 20281,
	"./slider.jsx": 20281,
	"./slider.module.scss": 62504,
	"./steps": 60753,
	"./steps.jsx": 60753,
	"./steps.module.scss": 12304,
	"./subtitle": 81750,
	"./subtitle.jsx": 81750,
	"./subtitle.module.scss": 55359,
	"./text": 87675,
	"./text.jsx": 87675,
	"./text.module.scss": 98354,
	"./textincolumns": 59165,
	"./textincolumns.jsx": 59165,
	"./textincolumns.module.scss": 81884,
	"./textwithlist": 10355,
	"./textwithlist.jsx": 10355,
	"./textwithlist.module.scss": 7946,
	"./video": 46185,
	"./video.jsx": 46185,
	"./video.module.scss": 80680,
	"./videowithbackground": 30565,
	"./videowithbackground.jsx": 30565,
	"./videowithbackground.module.scss": 30036
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 27278;